import { Helmet } from 'react-helmet-async';

const Meta = ({ title, description }) => {
  return (
    <Helmet>
    <title>{title || 'Deal Direct Homes'}</title>
    <meta name="description" content={description || 'Deal Direct Homes'} />
    
    {/* Essential fallbacks for social sharing */}
    {/* <meta property="og:title" content={title || 'Default Title'} />
    <meta property="og:description" content={description || 'Default description'} />
    <meta name="twitter:title" content={title || 'Default Title'} />
    <meta name="twitter:description" content={description || 'Default description'} /> */}
  </Helmet>
  );
};

export default Meta;